<template>
  <div class="ui basic tiny modal" :id="'hide-action-modal-' + _uid">
    <div v-if="loadingState === false && successState === false">
      <div class="ui error message" v-if="errorState === true">
        Sorry! Something has gone wrong. Please try deactivating this action again.
      </div>

      <div class="ui icon inverted header">
        <i class="warning sign icon"></i>
        Are you sure you want to deactivate this action: {{ currentAction.data.shortName }} ?
      </div>

      <div class="content">
        <p>This process is irreversible. The patient will not be able to see or track this action anymore.</p>
      </div>
      <br>
      <div class="actions">
        <div class="ui left floated button" @click="hideModal">No</div>
        <div class="ui right floated button" @click.once="deactivateSelectedAction">Yes, deactivate</div>
      </div>
    </div>

    <div v-if="loadingState === true">
      <div class="content">
        <center>
          <i class="massive loading spinner icon"></i>
        </center>
      </div>
    </div>

    <div v-if="loadingState === false && successState === true">
      <div class="ui icon inverted header">
        <i class="green checkmark icon"></i>
        {{ currentAction.data.shortName }} has been deactivated for the patient.
      </div>

      <div class="actions">
        <br>
        <center>
          <div class="ui big primary button" @click="reloadPage"><i class="refresh icon"></i>Reload Patient Data</div>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      selectedAction: {
        type: Object,
        required: true
      },
      patientId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        currentAction: JSON.parse(JSON.stringify(this.selectedAction)),
        modalId: '#hide-action-modal-' + this._uid,
        loadingState: false,
        successState: false,
        errorState: false
      }
    },
    computed: {
      userPlansRequestUrl: function() {
        return process.env.API_URL + process.env.PROGRAM_ID + '/programUsers/' + this.patientId + '/userPlans';
      },
      remindersRequestUrl: function() {
        return process.env.API_URL  + process.env.PROGRAM_ID + '/patients/' + this.patientId + '/userPlans/' + this.currentAction.id + '/reminder'; // TODO: This is 403 forbidden. needs to be updated.
      }

    },
    methods: {
      reloadPage: function(){
        window.location.reload();
      },

      hideModal: function() {
        $(this.modalId).modal('hide');
      },

      deactivateSelectedAction: function(){

        this.errorState = false;
        this.loadingState = true;

        this.currentAction.reminders[0].data.notification.timestamps = [];
        this.currentAction.data.deletedStatus = true;
        this.currentAction.data.deletedTimestamp = Date.now();
        let payload = this.currentAction;

        //this unsets the reminders
        this.$http.put(this.remindersRequestUrl, payload.reminders[0]).then(()=>{
          this.$http.put(this.userPlansRequestUrl, [payload]).then(()=>{
            this.successState = true;
            this.loadingState = false;
          }, (error)=>{
            Rollbar.error("Error in deactivating userPlans for a user", error, payload);
            this.successState = false;
            this.loadingState = false;
            this.errorState = true;
          })
        }, (error)=> {
          Rollbar.error("Error in unsetting reminders", error, payload);
          this.successState = false;
          this.loadingState = false;
          this.errorState = true;
        })

      },

    },
    watch: {
      selectedAction: function() {
        this.currentAction = JSON.parse(JSON.stringify(this.selectedAction));
      },
    },
    mounted() {

    },
    beforeDestroy() {
      let modal = document.querySelector(this.modalId);
      if (modal !== null) {
        modal.remove();
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/patients/PatientActionHideModal.vue